import React from 'react';

const About = () => {
  return (
    <div name = "about" 
    className="w-full  py-12 md-h-screen bg-gradient-to-r from-sky-950 via-slate-800 to-slate-900">
      <div className="max-w-screen-lg px-9 md:py-5 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-1">
      <p className='text-4xl text-white font-bold inline border-b-4'>About</p>
        </div>
        <p className='text-white mt-10'>
        I’m a Computer Science graduate from Ningbo University of Technology, China. With over 3 years of experience specializing in user-friendly, 
        responsive designs for web and mobile applications.
        </p>
        <br/>
        <p className ='text-white'> I focus on building clean, intuitive user experiences grounded in strong usability principles 
          and scalable design systems. I turn complex ideas into simple, functional interfaces that deliver real value for users and businesses.
          </p>
         <br/>
          <p className=' text-white'>
      Alongside design, I have hands-on experience with frontend technologies including HTML, CSS, React, Next.js, and Tailwind CSS, 
      which allows me to design with real-world constraints in mind and collaborate more effectively with developers or build interfaces 
      myself when needed.
        </p>
        <br/>
        <p className=' text-white'>
       Outside of design, I’m also a professional photographer, which sharpens my eye for detail, composition, and visual storytelling.<br></br>
       Driven by curiosity, I constantly explore new trends, tools, and techniques to sharpen my skills and stay at the forefront of design and technology.
        </p>
      </div>
    </div>
  )
};

export default About;